<template>
  <div class="container-custom">
    <v-form ref="form" @submit.prevent="saveHandler">
      <Breadscrumbs
        :links="[
          {
            name: 'BannerCenter',
            to: {
              name: 'BannerCenter'
            }
          },
          {
            name: 'Edit',
            to: {
              name: 'BannerEdit',
              params: {
                id: $route.params.id
              }
            }
          }
        ]"
      ></Breadscrumbs>
      <!-- page-actions -->
      <div class="page-actions">
        <h2>修改橫幅廣告</h2>
        <v-spacer></v-spacer>
        <button class="btn mr-5" @click="cancelHandler">
          <span>取消</span>
        </button>
        <button class="btn btn-primary" type='submit'>
          <span>儲存</span>
        </button>
      </div>
    </v-form>
    <!-- Block 修改橫幅廣告 -->
    <SlidebannerCreateEdit></SlidebannerCreateEdit>
    <LangDialog :isOpen.sync="isLangOpen" @confirm-submit="saveHandler()"></LangDialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import SlidebannerCreateEdit from '@/views/B-12__SlideBanner/c/SlidebannerCreateEdit.vue';
import LangDialog from '@/components/LangSubmitDialog.vue';

export default {
  components: {
    Breadscrumbs,
    SlidebannerCreateEdit,
    LangDialog,
  },
  data: () => ({
    isLangOpen: false,
  }),
  computed: {
    ...mapState(['lang']),
    ...mapState('slidebanner', ['slidebanner']),
  },
  async created() {
    if (this.$route.params.id) {
      await this.getSlidebanner(this.$route.params.id);
    }
  },
  methods: {
    ...mapActions('slidebanner', {
      getSlidebanner: 'findById',
      save: 'save',
    }),
    cancelHandler() {
      this.$router.push({ name: 'BannerCenter' });
    },
    saveHandler() {
      if (this.isLangOpen || !this.lang.id) {
        this.errors = [];
        if (this.$refs.form.validate()) {
          if (!this.slidebanner.bu_id) {
            this.errors.push('BU required.');
          } else if (!this.slidebanner.title) {
            this.errors.push('標題 required.');
          } else if (!this.slidebanner.position) {
            this.errors.push('Position required.');
          } else if (!this.slidebanner.type) {
            this.errors.push('Type required.');
          } else if (!this.slidebanner.visual) {
            this.errors.push('Visual required.');
          } else if (!this.slidebanner.mobile_visual) {
            this.errors.push('Visual for Mobile required.');
          }
          if (this.errors.length > 0) {
            /* eslint-disable */
            alert(this.errors);
            /* eslint-disable */
            return false;
          }
          this.save(this.slidebanner).then(() => {
            this.$router.push({ name: 'BannerCenter' });
          });
        }
      } else {
        this.isLangOpen = true;
      }
    },
  },
};
</script>

<style></style>
